import { render, staticRenderFns } from "./privacyPage.vue?vue&type=template&id=cd74056c&scoped=true"
import script from "./privacyPage.vue?vue&type=script&lang=js"
export * from "./privacyPage.vue?vue&type=script&lang=js"
import style0 from "./privacyPage.vue?vue&type=style&index=0&id=cd74056c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd74056c",
  null
  
)

export default component.exports